import { Helmet } from "react-helmet";
import Header from '../header/Header';
import HeroDispositivos from './dispositivos/HeroDispositivos.js';
import Carousel from './home/Carousel';
import ListadoDispositivos from './dispositivos/ListadoDispositivos';
import Footer from '../footer/Footer';


function Dispositivos() {
    
  return (
    <>
        <Helmet>
            <link
            rel="stylesheet"
            type="text/css"
            charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
            />
            <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
            />
            <meta charSet="utf-8" />
            <title>Dispositivos - XDigital Neo</title>
        </Helmet>
        <Header />
        <HeroDispositivos />
        <Carousel />
        <ListadoDispositivos />
        <Footer />
    </>
  )
}

export default Dispositivos